import {useEffect} from "react";
import {Container} from "./styled";
import {toggleBodyScroll} from "utils";
import {Fragment} from "react/jsx-runtime";
import {SpinnerLoader, Image} from "components";
import {useAppSelector, useBreakpoints} from "hooks";

interface FullScreenLoaderProps {}

export const FullScreenLoader: React.FC<FullScreenLoaderProps> = () => {
  const {upSm} = useBreakpoints();
  const {showFullScreenLoader} = useAppSelector("layout");

  useEffect(() => {
    toggleBodyScroll(showFullScreenLoader);
  }, [showFullScreenLoader]);

  return showFullScreenLoader ? (
    <Container>
      <Image
        width={300}
        height={60}
        objectFit="contain"
        src="/images/logo-horizontal.png"
      />
      <SpinnerLoader size={upSm ? 50 : 45} />
    </Container>
  ) : (
    <Fragment />
  );
};
